/*
 *   File : rebalance-history.js
 *   Author : https://evoqins.com
 *   Description : Rebalance history page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Custom components
import { CustomDataTable } from '../../Components/DataTable';

const REBALANCE_DATA = [
    {
        date: "12 Sep 2023",
        triggered_by: "Admin",
        users_impacted: "122",
        changes_summary: {
            added_fund: "Nippon Indian Large Cap Fund",
            allocation: "10",
            changed_allocation: "Bandhan Infrastructure Growth plan",
            changed_allocation_from: "30",
            changed_allocation_to: "10"
        },
    },
    {
        date: "12 Sep 2023",
        triggered_by: "Admin",
        users_impacted: "122",
        changes_summary: {
            added_fund: "Nippon Indian Large Cap Fund",
            allocation: "10",
            changed_allocation: "Bandhan Infrastructure Growth plan",
            changed_allocation_from: "30",
            changed_allocation_to: "10"
        },
    },
    {
        date: "12 Sep 2023",
        triggered_by: "Admin",
        users_impacted: "122",
        changes_summary: {
            added_fund: "Nippon Indian Large Cap Fund",
            allocation: "10",
            changed_allocation: "Bandhan Infrastructure Growth plan",
            changed_allocation_from: "30",
            changed_allocation_to: "10"
        },
    },
    {
        date: "12 Sep 2023",
        triggered_by: "Admin",
        users_impacted: "122",
        changes_summary: {
            added_fund: "Nippon Indian Large Cap Fund",
            allocation: "10",
            changed_allocation: "Bandhan Infrastructure Growth plan",
            changed_allocation_from: "30",
            changed_allocation_to: "10"
        },
    },
];

const RebalanceHistory = () => {

    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    // handle table page change 
    const _handleTablePageChange = (page_num) => {
        setCurrentPage(page_num);
    };


    // re-balance history data table column 
    const REBALANCE_TABLE_COLUMN = [
        {
            name: 'Date',
            selector: row => row.date,
            width: "160px"
        },
        {
            name: 'Triggered by',
            selector: (row) => row.triggered_by,
            width: "160px"
        },
        {
            name: 'Users impacted',
            selector: row => row.users_impacted,
            width: "160px"
        },
        {
            name: 'Changes summary',
            cell: (row) =>
                <div className='d-flex flex-column gap-10px'>
                    <p className='mb-0'>
                        Added fund: <span className='pe-1 e-font-weight-500'>{row.changes_summary.added_fund}</span>
                        ,allocation <span className='e-font-weight-500'>{row.changes_summary.allocation}%</span>
                    </p>
                    <p className='mb-0'>
                        Changed allocation: <span className='pe-1 e-font-weight-500'>{row.changes_summary.changed_allocation}</span>
                        <span className='pe-1 e-font-weight-400'>{row.changes_summary.changed_allocation_from}%</span>
                        to
                        <span className='ps-1 e-font-weight-500'>{row.changes_summary.changed_allocation_to}%</span>
                    </p>
                </div>,
            width: "600px"
        },
    ];

    return (
        <section className='e-section-height pb-5' >
            <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                <p className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-24px'>
                    <span className='text-decoration-hover-underline cursor-pointer'
                        onClick={() => navigate("/baskets")}>Manage Baskets</span> / <span className='e-font-weight-600'>Rebalance History</span>
                </p>
            </div>

            <div className='padding-52px-lr margin--80px-top'>
                {/* Rebalance history  */}
                <div className='e-bg-white border-radius-16 '>
                    <div className='padding-32px-lr padding-32px-top'>
                        <h4 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                            Rebalance history
                        </h4>
                    </div>
                    {/*  Rebalance history table */}
                    <div className='e-data-table-wrapper pt-4 padding-32px-bottom'>
                        <CustomDataTable columns={REBALANCE_TABLE_COLUMN}
                            data={REBALANCE_DATA}
                            pagination={true}
                            paginationPerPage={10}
                            paginationTotalRows={REBALANCE_DATA.length}
                            // lastPage={listData.total_page}
                            onChangePage={_handleTablePageChange} />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default RebalanceHistory;
